const { angular } = window;

angular.module('wcm.core').constant('MANAGE_BLOCK_CONFIG', {
  stepItemsLimit: 10
});
